module.exports = new __parcel__URL__("Design Decision Hover.c4751033.svg").toString();